import * as userSlice from './slices/UserSlice';
import * as gameSlice from './slices/GameSlice';
import * as coinflipSlice from './slices/CoinflipSlice';
import * as jackpotSlice from './slices/jackpotSlice';
import * as blackjackSlice from './slices/blackjackSlice';
import * as blackjackLobbySlice from './slices/blackjackLobbySlice';
import * as walletSlice from './slices/WalletSlice';
import * as chatSlice from './slices/chatSlice';
import * as uiSlice from './slices/uiSlice';
import * as userTransactionsSlice from './slices/UserTransactionsSlice';

const userActions = {
    SET_USER_DATA: userSlice.setData,
    USER_UPDATE_BALANCE: userSlice.updateBalance,
    CHANGE_USER_BALANCE: userSlice.changeBalance,
    RESET_USER_DATA: userSlice.resetData,
};

const coinflipActions = {
    SET_COINFLIP_GAMES: coinflipSlice.setData,
    RESET_COINFLIP_GAMES: coinflipSlice.resetData,
    ADD_COINFLIP_GAME: coinflipSlice.addCoinflipoGame,
    REMOVE_COINFLIP_GAME: coinflipSlice.removeSingleCoinflipGame,
    UPDATE_SINGLE_COINFLIP_GAME: coinflipSlice.updateSingleCoinflipGame,
};

const jackpotActions = {
    SET_JACKPOT_DATA: jackpotSlice.setData,
    RESET_JACKPOT_DATA: jackpotSlice.resetData,
    SET_JACKPOT_ROOMS: jackpotSlice.setJackpotRooms,
};

const blackjackActions = {
    SET_BLACKJACK_DATA: blackjackSlice.setData,
    BLACKJACK_STORE_PLAYER_CARDS: blackjackSlice.storePlayerCards,
    BLACKJACK_STORE_PLAYER_TICKETS: blackjackSlice.storePlayerTickets,
    BLACKJACK_STORE_PLAYER_STATUS: blackjackSlice.storePlayerStatus,
    BLACKJACK_STORE_PLAYER_READY_TO_PLAY: blackjackSlice.storePlayerReadyToPlay,
    RESET_BLACKJACK_DATA: blackjackSlice.resetData,
    SET_BLACKJACK_lOBBY_DATA: blackjackLobbySlice.setData,
    RESET_BLACKJACK_lOBBY_DATA: blackjackLobbySlice.resetData,
};

const chatActions = {
    SET_CHAT_DATA: chatSlice.setData,
    RESET_CHAT_DATA: chatSlice.resetData,
    ADD_CHAT_MESSAGE: chatSlice.addMessage,
    LIKE_CHAT_MESSAGE: chatSlice.likeMessage,
    UNLIKE_CHAT_MESSAGE: chatSlice.unLikeMessage,
    COLLAPSE_CHAT: chatSlice.collapseChat,
    SET_NUMBER_OF_USERS: chatSlice.setNumberOfConnected,
};

const walletActions = {
    SET_WALLET_DATA: walletSlice.setData,
    RESET_WALLET_DATA: walletSlice.resetData,
};

const uiActions = {
    SET_UI_DATA: uiSlice.setData,
    RESET_UI_DATA: uiSlice.resetData,
};

const userTransactionsActions = {
    SET_USER_TRANSACTIONS: userTransactionsSlice.setData,
    RESET_USER_TRANSACTIONS: userTransactionsSlice.resetData,
    ADD_USER_DEPOSIT: userTransactionsSlice.addDeposit,
    ADD_USER_WIDTHRAWAL: userTransactionsSlice.addWidthdrawal,
};

export const actions = {
    SET_GAME_DATA: gameSlice.setData,
    RESET_GAME_DATA: gameSlice.resetData,
    ...userActions,
    ...blackjackActions,
    ...jackpotActions,
    ...coinflipActions,
    ...walletActions,
    ...chatActions,
    ...uiActions,
    ...userTransactionsActions,
};

export type ActionKeys = keyof typeof actions;
